import { render } from "./projectName.vue?vue&type=template&id=20327bf6&scoped=true"
import script from "./projectName.vue?vue&type=script&lang=js"
export * from "./projectName.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-20327bf6"

export default script